/** Routes that should NOT show the app banner (single-segment paths that aren't meetings) */
const EXCLUDED_PATHS = new Set([
  "/login",
  "/forgot-password",
  "/recovery",
  "/recoveryc",
  "/maintenance",
  "/maintenance-notification",
  "/meeting-not-found",
]);

/**
 * Returns true if the pathname is a meeting-related route where the
 * mobile app banner should appear:
 *   /:roomId           (single segment, excluding known non-meeting routes)
 *   /event/:slug
 *   /webinar/:id/event
 *   /webinar/:id/register
 */
export function isTargetBannerRoute(pathname) {
  // /event/:slug
  if (/^\/event\/[^/]+$/.test(pathname)) return true;

  // /webinar/:id/event or /webinar/:id/register
  if (/^\/webinar\/[^/]+\/(event|register)$/.test(pathname)) return true;

  // /:roomId — single segment, not in exclusion list, not a multi-segment path
  if (/^\/[^/]+$/.test(pathname) && !EXCLUDED_PATHS.has(pathname)) return true;

  return false;
}
